export default {
  getPinCode: `query GetPinCode {
    pinCode
  }`,
  getCateringData: `
  query getCateringData($date: String!, $office: Int! ) {
    getCateringData(date: $date, office: $office) {
        users {
            id,
            name,
            email,
            office,
            orders {
                breakfast {
                    id,
                    menuEvent,
                    meal,
                    served
                },
                lunch {
                    id,
                    menuEvent,
                    meal,
                    served
                },
                dinner {
                    id,
                    menuEvent,
                    meal,
                    served
                }
            }
        },
        mealsInfo {
            id,
            name,
            dietInfo {
                name
            }
        }
    }
}`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/catering.js